<div class="flex flex-col justify-center items-center">
  <div class="relative w-full max-w-sm md:max-w-xsm lg:max-w-sm overflow-hidden">
    <div *ngIf="showComingSoonRibbon" class="absolute -left-[55px] top-[30px] flex w-[200px] items-center justify-center rotate-[-45deg] bg-varroc-accent py-1 text-center text-[10px] font-bold uppercase tracking-[0.2em] text-white shadow-lg pointer-events-none z-10">
      Launched
    </div>
    <img [src]="mainImage" alt="Main Image" class="main-gallery-image rounded-md w-full h-auto">
  </div>
  <div
    class="flex mt-2 gap-2 sm:gap-4 md:gap-5 thumbnails w-full max-w-sm md:max-w-xsm lg:max-w-sm overflow-x-auto overflow-y-hidden py-3 sm:py-4 md:py-5 px-3 sm:px-4 md:px-5">
    <img *ngFor="let image of images" [src]="image" alt="Thumbnail" (click)="changeImage(image)"
      class="rounded-md w-12 h-12 sm:w-16 sm:h-16 md:w-18 md:h-18 cursor-pointer flex-shrink-0">
  </div>
</div>